// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wifi-no-filled"},"children":[{"tag":"g","attrs":{"id":"Union"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 8.5V1H11V8.5H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0039 10H11V12.0039H13.0039V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.37875 6.725C3.64856 4.90458 6.27649 3.75138 9 3.26544V14H15V3.26526C17.7237 3.75108 20.3519 4.90427 22.6219 6.72487L23.401 7.34975L12.0003 21.6008L0.599609 7.34989L1.37875 6.725Z"}}]}]}]};

const WifiNoFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi-no-filled',
    ref,
    icon: element,
  },
));

WifiNoFilledIcon.displayName = 'WifiNoFilledIcon';

export default WifiNoFilledIcon;
